import Swiper, { Pagination } from 'swiper';

const Carousel = () => {
  const mySwiper = new Swiper('.swiper-container', {
    modules: [Pagination],
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoHeight: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    grabCursor: true,
    breakpoints: {
      1024: {
        slidesPerView: 1,
        slidesPerGroup: 1

      },
      640: {
        slidesPerView: 1,
        slidesPerGroup: 1
        // spaceBetween: 20,
      }
    },
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // },
  });
}

export default Carousel;
